import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


export interface ConfirmDialogData {
  title?: string;
  message?: string;
  okText?: string;
  checkboxMessage?: CheckboxData;
  cancelText?: string;
  inputLabel?: string;
  inputRequired?: boolean;
}

export interface CheckboxData {
  message: string;
  show: boolean;
}

export interface ConfirmDialogResult {
  confirmed?: boolean;
  message?: string;
  checked?: boolean;
}


@Component({
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  public title: string;
  public message: string;
  public okText: string;
  public cancelText: string;
  public inputLabel: string;
  public inputValue: string;
  public inputRequired: boolean;
  public checkboxMessage: CheckboxData | undefined;
  public checked = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private readonly data: ConfirmDialogData,
    private readonly matDialogRef: MatDialogRef<ConfirmDialogComponent, ConfirmDialogResult>,
  ) {
    this.title = this.data.title;
    this.message = this.data.message;
    this.okText = this.data.okText;
    this.cancelText = this.data.cancelText;
    this.inputLabel = this.data.inputLabel;
    this.inputRequired = this.data.inputRequired;
    this.checkboxMessage = this.data.checkboxMessage;
  }

  public confirm(): void {
    this.matDialogRef.close({
      confirmed: true,
      message: this.inputValue,
      checked: this.checked
    });
  }

  public cancel(): void {
    this.matDialogRef.close({
      confirmed: false,
      message: this.inputValue,
      checked: this.checked
    });
  }
}
